module.exports = __webpack_public_path__ + "img/example-dogs-output.c46db80a.jpg";